// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mejG9","text":"Button_text__1YnkW","small":"Button_small__1RkpR","edge":"Button_edge__3Qg59","round":"Button_round__23SKm","icon":"Button_icon__1l3gD"};